import { TextField } from '@cmsgov/ds-medicare-gov';
import React from 'react';
import the from '../objects/the';
import './css/hidden.error.message.css';

interface InputFieldProps {
    errorMessage: string | null
    id?: string | null
    inputRef?: any
    label: JSX.Element | string
    name: string

    onClick?: () => void
    onBlur: (event: any) => void
    onChange: (event: any) => void
    onFocus?: () => void
    style?: React.CSSProperties
    type?: 'text' | 'password'
    value: string
    hint?: JSX.Element
    disabled?: boolean
}

export default function InputField(props: InputFieldProps) {
    const getErrorMessage = () => {
        if (!props.errorMessage)
            return null;
        return <>
            <div style={{
                color: the.color.darkRed,
                fontSize: 14,
            }}>{props.errorMessage}</div>
        </>;
    };

    return <>
        {/* @ts-ignore */}
        <TextField {...props}/>
        {getErrorMessage()}
    </>;
}